import {FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import {RTL} from "../cache/CacheRtl";

const SelectCom = ({background="#F9FAFB",
  defaultValue,
  contrast = "#F9FAFB",
  mainItem,
  onBlur,
  id,
  fullWidth,
  width,
  label,
  disabled,
  marginLeft,
  hidden,
  height ="42px",
  onChange,
  onChangeReal,
  value,
  children}) => {

  // Determine if we should use fullWidth based on width prop
  const shouldBeFullWidth = fullWidth || width === "100%";

  return (
      <RTL>
        <FormControl
            fullWidth={shouldBeFullWidth}
            disabled={disabled}
            sx={{
                alignSelf: "end",
                marginLeft: {marginLeft},
                display: `${hidden ? "none" : "auto"}`,
                ...(shouldBeFullWidth ? { width: "100%" } : {})
            }}>
          <InputLabel id="demo-simple-select-label">{label}</InputLabel>
          <Select
              fullWidth={shouldBeFullWidth}
              onBlur={onBlur}
              onChange={onChangeReal ? onChangeReal : (e) => onChange(e.target.value)}
              sx={{
                  height: {height},
                  ...(shouldBeFullWidth ? { width: "100%" } : { width: {width} }),
                  backgroundColor: {background},
                  color: {contrast},
                  maxHeight: {height},
                  "& .MuiSvgIcon-root" : {
                      color: {contrast}
                  }
              }}
              id={id}
              label={label}
              value={value}
          >
            <MenuItem value={defaultValue}>
              <em>{mainItem}</em>
            </MenuItem>
            {children}
          </Select>
        </FormControl>
      </RTL>
  );
};

export default SelectCom;
